import { lazy } from "react";

const AddRockedProduct = lazy(() =>
  import("../components/ContentUnit/Products/AddRockedProduct/AddRockedProduct")
);

const ActiveProduct = lazy(() =>
  import("../components/ContentUnit/Products/activeProduct/ActiveProduct")
);
const ChangeProductStatus = lazy(() =>
  import(
    "../components/ContentUnit/Products/changProductStatus/ChangeProductStatus"
  )
);
const FinishedProduct = lazy(() =>
  import("../components/ContentUnit/Products/finishedProduct/FinishedProduct")
);
const MyProduct = lazy(() =>
  import("../components/ContentUnit/Products/myProduct/MyProduct")
);
const NewProduct = lazy(() =>
  import("../components/ContentUnit/Products/newProducts/NewProduct")
);
const UnApprovedProduct = lazy(() =>
  import(
    "../components/ContentUnit/Products/unapprovedProducts/UnApprovedProduct"
  )
);
const WareHouseProduct = lazy(() =>
  import(
    "../components/ContentUnit/Products/warehouseProducts/WareHouseProduct"
  )
);
const StagnantProduct = lazy(() =>
  import("../components/ContentUnit/Products/stagnantProducts/StagnantProduct")
);

const ContentGenerator = lazy(() =>
  import("../components/ContentUnit/Contents/newContent/ContentGenerator")
);
const ContentShower = lazy(() =>
  import("../components/ContentUnit/Contents/viewContent/ViewContent")
);

const SlidersContent = lazy(() =>
  import("../components/ContentUnit/Sliders/SlidersContent")
);

const UpdataSlide = lazy(() =>
  import("../components/ContentUnit/Sliders/EditSlide")
);

const AddQuestion = lazy(() =>
  import("../components/ContentUnit/FrequentQuestion/addQuestion/AddQuestion")
);

const AddCategoryQuestion = lazy(() =>
  import(
    "../components/ContentUnit/FrequentQuestion/addQuestionCategory/AddQuestionCategory"
  )
);

const UpdateAskQuestion = lazy(() =>
  import(
    "../components/ContentUnit/FrequentQuestion/addQuestion/UpdateAskQuestion"
  )
);

const CommonQuestionMenus = lazy(() =>
  import("../components/ContentUnit/Menus/ProductCategory")
);

const ContentMenus = lazy(() =>
  import("../components/ContentUnit/Menus/Contents")
);

const ProductPropertyMenue = lazy(() =>
  import("../components/ContentUnit/Menus/ProductProperty")
);

const LevelFirst = lazy(() =>
  import("../components/ContentUnit/ProductProperty/level1/LevelFirst")
);

const LevelSecond = lazy(() =>
  import("../components/ContentUnit/ProductProperty/level2/LevelSecond")
);

const Notification = lazy(() =>
  import("../components/ContentUnit/Notification/Notification")
);

const AreasCoveredMenu = lazy(() =>
  import("../components/ContentUnit/Menus/AreasCovered")
);

const CountryRoute = lazy(() =>
  import("../components/ContentUnit/AreasCovered/Counteries/Counteries")
);

const ProvinceRoute = lazy(() =>
  import("../components/ContentUnit/AreasCovered/Provinces/Provinces")
);

const CityRoute = lazy(() =>
  import("../components/ContentUnit/AreasCovered/Cities/Cities")
);

const AreaRoute = lazy(() =>
  import("../components/ContentUnit/AreasCovered/Areas/Area")
);

const ProductCategoryMenue = lazy(() =>
  import("../components/ContentUnit/Menus/ProductCategoryMenu")
);

const LevelFirstProdcutRoute = lazy(() =>
  import("../components/ContentUnit/ProductCategory/LevelFirst/LevelFirst")
);
const LevelSecondProductRoute = lazy(() =>
  import("../components/ContentUnit/ProductCategory/LevelSecond/LeveleSecond")
);
const LevelThirdProductRoute = lazy(() =>
  import("../components/ContentUnit/ProductCategory/LevelThird/LevelThid")
);

const AddBrand = lazy(() =>
  import("../components/ContentUnit/ProductCategory/AddBrand/AddBrand")
);

const AddGender = lazy(() =>
  import("../components/ContentUnit/ProductCategory/gender/Gender")
);

const AddOccation = lazy(() =>
  import("../components/ContentUnit/ProductCategory/Occations/Occation")
);

const ProductMenu = lazy(() =>
  import("../components/ContentUnit/Menus/ProductMenu")
);

const StagnantProductRoute = lazy(() =>
  import("../components/ContentUnit/Products/stagnantProducts/StagnantProduct")
);

const FinishedProdcutRoute = lazy(() =>
  import("../components/ContentUnit/Products/finishedProduct/FinishedProduct")
);

const DashboardProduct = lazy(() =>
  import("../components/ContentUnit/Dashboard/DashboardContent")
);

const BlogCategoy = lazy(() =>
  import("../components/ContentUnit/Contents/AddBlogCategory/BlogCategory")
);

// blogCategory
const SubmitPorduct = lazy(() =>
  import("../components/ContentUnit/Products/SubmitProduct/SubmitPorduct")
);

const EditContent = lazy(() =>
  import("../components/ContentUnit/Contents/viewContent/EditContent")
);

const EditProduct = lazy(() =>
  import("../components/ContentUnit/Products/editProduct/EditProduct")
);

const AddTableTextTempate = lazy(() =>
  import("../components/ContentUnit/ProductCategory/TextTemplate/TextTemplate")
);

const AddOfficialHoliday = lazy(() =>
  import("../components/ContentUnit/OfficialHoliday/OfficialHoliday")
);

export const ContentRoute = [
  // Content sidebar route
  {
    path: "content/add-blog",
    className: "add-blog",
    component: <ContentGenerator />,
  },
  {
    path: "content/view-blog",
    className: "view-blog",
    component: <ContentShower />,
  },
  // sliders sidebar route
  {
    path: "slider/top-slider",
    className: "top-slider",
    component: <SlidersContent />,
  },
  // Product sidebar route
  {
    path: "/products/activeProduct",
    className: "active-product",
    component: <ActiveProduct />,
  },
  {
    path: "/products/changeProductStatus",
    className: "change-product-status",
    component: <ChangeProductStatus />,
  },
  {
    path: "/products/finished",
    className: "finished-product",
    component: <FinishedProduct />,
  },
  {
    path: "/products/myProduct",
    className: "supplier",
    component: <MyProduct />,
  },
  {
    path: "/products/submitedProduct",
    className: "supplier",
    component: <SubmitPorduct />,
  },
  {
    path: "/products/addNewProduct",
    className: "add-product",
    component: <NewProduct />,
  },
  {
    path: "/stag",
    className: "stage-product",
    component: <StagnantProduct />,
  },
  {
    path: "/rejected",
    className: "rejected-product",
    component: <UnApprovedProduct />,
  },
  {
    path: "recedAnbar",
    className: "reced-anbar",
    component: <WareHouseProduct />,
  },
  {
    path: "slider/edit-slider",
    className: "update-slider",
    component: <UpdataSlide />,
  },
  {
    path: "/commonQuestion/add-category-question",
    className: "add-category-question",
    component: <AddCategoryQuestion />,
  },
  {
    path: "/commonQuestion/add-question",
    className: "add-category-question",
    component: <AddQuestion />,
  },
  {
    path: "/commonQuestion/edit-ask-question",
    className: "update-ask-question",
    component: <UpdateAskQuestion />,
  },
  {
    path: "/commonQuestion",
    className: "common-question-menu",
    component: <CommonQuestionMenus />,
  },
  {
    path: "/content",
    className: "contents-meus",
    component: <ContentMenus />,
  },
  {
    path: "/productProperty",
    className: "product-property-meus",
    component: <ProductPropertyMenue />,
  },
  {
    path: "/productProperty/level-first",
    className: "product-property-level1",
    component: <LevelFirst />,
  },
  {
    path: "/productProperty/level-second",
    className: "product-property-level2",
    component: <LevelSecond />,
  },
  {
    path: "/notification",
    className: "notification-message",
    component: <Notification />,
  },
  {
    path: "/areasCovered",
    className: "areas-covered",
    component: <AreasCoveredMenu />,
  },
  {
    path: "/areasCovered/country",
    className: "country",
    component: <CountryRoute />,
  },
  {
    path: "/areasCovered/province",
    className: "province",
    component: <ProvinceRoute />,
  },
  {
    path: "/areasCovered/city",
    className: "city",
    component: <CityRoute />,
  },
  {
    path: "/areasCovered/area",
    className: "area",
    component: <AreaRoute />,
  },
  {
    path: "/productCategory",
    className: "product-category",
    component: <ProductCategoryMenue />,
  },
  {
    path: "/product-category-level1",
    className: "product-category",
    component: <ProductCategoryMenue />,
  },
  {
    path: "/productCategory",
    className: "product-category",
    component: <ProductCategoryMenue />,
  },

  {
    path: "/productCategory/level1-product-category",
    className: "product-category",
    component: <LevelFirstProdcutRoute />,
  },
  {
    path: "/productCategory/level2-product-category",
    className: "product-category",
    component: <LevelSecondProductRoute />,
  },
  {
    path: "/productCategory/level3-product-category",
    className: "product-category",
    component: <LevelThirdProductRoute />,
  },
  {
    path: "/productCategory/addBrand",
    className: "product-category",
    component: <AddBrand />,
  },
  {
    path: "/productCategory/addGender",
    className: "product-category",
    component: <AddGender />,
  },
  {
    path: "/productCategory/addOccation",
    className: "product-category",
    component: <AddOccation />,
  },
  {
    path: "/products",
    className: "product",
    component: <ProductMenu />,
  },
  {
    path: "/dashboard",
    className: "finished-product",
    component: <DashboardProduct />,
  },
  {
    path: "products/rockedProduct",
    className: "stagnant-product",
    component: <StagnantProductRoute />,
  },
  {
    path: "/products/finishedProduct",
    className: "finished-product",
    component: <FinishedProdcutRoute />,
  },
  {
    path: "products/addRockedProduct",
    className: "finished-product",
    component: <AddRockedProduct />,
  },
  {
    path: "content/blogCategory",
    className: "blog-category",
    component: <BlogCategoy />,
  },
  {
    path: "content/view-blog/editContent",
    className: "edi-content",
    component: <EditContent />,
  },
  {
    path: "products/editProduct",
    className: "edit-product",
    component: <EditProduct />,
  },
  {
    path: "/productCategory/addTextTemplateTable",
    className: "add-text-template-table",
    component: <AddTableTextTempate />,
  },
  {
    path: "/officialHoliday",
    className: "add-official-holiday",
    component: <AddOfficialHoliday />,
  },
];

// {
// finishedProduct
//   id: "1",
//   name: "کد تخفیف",
//   path: `${BaseQuestionURL}/offCode`,
//   icon: <MdOutlineDashboardCustomize size={25} />,
//   color: "#0062FF",
//   type: "menu",
// },
// {
//   id: "1",
//   name: "تخفیف بر اساس دسته بندی یا انبار",
//   path: `${BaseQuestionURL}/offInventory`,
//   icon: <MdOutlineDashboardCustomize size={25} />,
//   color: "#0062FF",
//   type: "menu",
// },
// {
//   id: "1",
//   name: "کنترل  قیمت",
//   path: `${BaseQuestionURL}/controllPrice`,
//   icon: <MdOutlineDashboardCustomize size={25} />,
//   color: "#0062FF",
//   type: "menu",
// },
